import { NgModule } from '@angular/core';
import { RouterModule, Router, NavigationStart, NavigationError, NavigationEnd, NavigationCancel } from '@angular/router';
import { LoadingBarModule, LoadingBarService } from '@ngx-loading-bar/core';

var LoadingBarRouterModule = /** @class */ (function () {
    function LoadingBarRouterModule(router, loadingBar) {
        router.events.subscribe(function (event) {
            if (event instanceof NavigationStart) {
                loadingBar.start();
            }
            if ((event instanceof NavigationError || event instanceof NavigationEnd || event instanceof NavigationCancel)) {
                loadingBar.complete();
            }
        });
    }
    return LoadingBarRouterModule;
}());
LoadingBarRouterModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    RouterModule,
                    LoadingBarModule.forRoot(),
                ],
                exports: [
                    RouterModule,
                    LoadingBarModule,
                ],
            },] },
];
LoadingBarRouterModule.ctorParameters = function () { return [
    { type: Router, },
    { type: LoadingBarService, },
]; };

export { LoadingBarRouterModule };
//# sourceMappingURL=ngx-loading-bar-router.js.map



//////////////////
// WEBPACK FOOTER
// C:/Projects/USilence/USilence/Client/node_modules/@ngx-loading-bar/router/esm5/ngx-loading-bar-router.js
// module id = ../../../../@ngx-loading-bar/router/esm5/ngx-loading-bar-router.js
// module chunks = vendor